import {
    type TranslationFunction,
    useTranslator
} from 'tradera/lang/translate';

export const getPaymentMethodName = (
    paymentMethod: string,
    t: TranslationFunction
) => {
    switch (paymentMethod) {
        case 'Mastercard':
        case 'Visa':
        case 'VisaMasterCard':
        case 'Card':
            return t('syi_payment_option_VisaMasterCard');
        case 'Paynova':
            return t('syi_payment_option_Paynova');
        case 'PayPal':
            return t('syi_payment_option_PayPal');
        case 'SwishHandel':
            return t('syi_payment_option_Swish');
        case 'ApplePay':
            return t('syi_payment_option_ApplePay');
        case 'GooglePay':
            return t('syi_payment_option_GooglePay');
        case 'Klarna':
            return t('syi_payment_option_Klarna');
        case 'NoPaymentMethod':
            return t('syi_payment_option_NoPaymentMethod');
        case 'Invoice':
        case 'Wallet':
            return t('syi_payment_option_balance');
        case 'Trustly':
            return t('syi_payment_option_trustly');
        default:
            return null;
    }
};

type PaymentMethodNameProps = {
    paymentMethod: string;
};

export const PaymentMethodName = ({
    paymentMethod
}: PaymentMethodNameProps) => {
    const { t } = useTranslator();

    return <span>{getPaymentMethodName(paymentMethod, t)}</span>;
};
